<div class="container-fluid py-3">
  <div class="row">
    <div class="col-12">
      <p-table #dt
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [filterDelay]="0"
        [loading]="accessDoorTypeService.loading"
        [paginator]="true"
        [rows]="10"
        [rowHover]="true"
        [rowsPerPageOptions]="[10,25,50]"
        [showCurrentPageReport]="true"
        [value]="accessDoorTypeService.accessDoorTypes">
        <ng-template pTemplate="caption">
          <div class="container-fluid">
            <div class="row">
              <div class="col-4 d-flex align-items-center">
                Tipos de puertas de acceso
              </div>
              <div class="col-8 text-end">
                <button
                  (click)="open()"
                  class="btn btn-success rounded-circle me-2">
                  <i class="material-icons mt-1">add</i>
                </button>
                <button
                  (click)="accessDoorTypeService.getAll()"
                  class="btn btn-primary rounded-circle me-2">
                  <i class="material-icons mt-1">refresh</i>
                </button>
              </div>
            </div>
          </div>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="accessDoorType">
              Tipo
              <p-sortIcon field="accessDoorType"></p-sortIcon>
              <p-columnFilter type="text" field="accessDoorType" display="menu"></p-columnFilter>
            </th>
            <th pSortableColumn="createdAt">
              Fecha
              <p-sortIcon field="createdAt"></p-sortIcon>
            </th>
            <th></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-accessDoorType>
          <tr class="p-selectable-row">
            <td>
              <span class="p-column-title">Tipo</span>
              {{ accessDoorType.accessDoorType }}
            </td>
            <td>
              <span class="p-column-title">Fecha</span>
              {{ accessDoorType.createdAt | date:'dd/MM/yyyy' }}
            </td>
            <td>
              <button
                (click)="delete(accessDoorType)"
                class="btn btn-sm btn-danger rounded-circle me-2 my-1">
                <i class="material-icons mt-1">delete</i>
              </button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
